import bridge from './bridge'

const noop = () => {}
const Owl = (window as any).Owl || noop

class Monitor {
  async init() {
    try {
      const userInfo = await bridge.getUserInfo()
      if (userInfo.userId) {
        window.Owl && window.Owl.setDimension({ unionId: userInfo.userId })
      }
    } catch (e) {
      console.log('monitor init error', e)
    }
  }

  captureMessage(error: string | SubErrorType, config = {} as ICatErrorModel) {
    const baseConfig: ICatErrorModel = {
      level: 'info',
      category: 'custom_info',
    }

    const tags = {
      ...baseConfig.tags,
      ...config.tags,
    }

    // 上报 自定义类别 错误异常
    Owl.addError(error, {
      ...baseConfig,
      ...config,
      ...tags,
    })
  }

  reportMetric(key: string, _tags = {}, value?: any): void {
    const metricManager = Owl.metricManager
    const tags = {
      ..._tags,
    }
    metricManager.setTags({
      ...tags,
    })
    metricManager.setMetric(key, value || 1)
    // 强制上报所有
    metricManager.report()
  }

  sendPoint(position: number) {
    // 在CAT后台展示时index N对应的是自定义性能点N+1
    if (Owl && Owl.addPoint && Owl.sendPoints) {
      Owl.addPoint({
        position,
      })
      // 发送数据
      Owl.sendPoints()
    }
  }
}

export default new Monitor()
